import { render } from "./CopyDetailsPannelValuesList.vue?vue&type=template&id=7ca18bc9"
import script from "./CopyDetailsPannelValuesList.vue?vue&type=script&lang=js"
export * from "./CopyDetailsPannelValuesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__